import { LOCALES } from 'i18n/locales';

export const createEnquiryPageIntl = {
    [LOCALES.ENGLISH]: {
        'createEnquiryPage.page.title': 'New enquiry - NUAR',
        'createEnquiryPage.title': 'New enquiry',
        'createEnquiryPage.subtitle': 'This enquiry will be available for review by the relevant asset owners and their third parties.',
        'createEnquiryPage.title.summary': 'New enquiry summary',
        'createEnquiryPage.select.enquiry.type.title': 'New enquiry',
        'createEnquiryPage.select.enquiry.type.subtitle': 'Enquiry type',
        'createEnquiryPage.enquiry.type.title': 'Utility enquiry type',
        'createEnquiryPage.enquiry.type.subtitle': 'The nature of this enquiry',
        'createEnquiryPage.planned.work': 'Planned works',
        'createEnquiryPage.unplanned.work': 'Unplanned or emergency work',
        'createEnquiryPage.enquiry.details': 'Enquiry details',
        'createEnquiryPage.select.enquiry.type.description': 'Organisational sponsor',
        'createEnquiryPage.radio.hint': 'Work carried out on behalf of this organisation',
        'createEnquiryPage.no.enquiry.types': 'You do not have access to create a planned or emergency enquiry. Contact your administrator.',
        'createEnquiryPage.more.info.about.enquiry.types': 'Working for a different organisation?',
        'createEnquiryPage.enquiry.type.info.unplanned': 'If this enquiry is on behalf of a different organisation, you will need to switch to that account.',
        'createEnquiryPage.enquiry.type.unplanned.notice': 'It is assumed that work will be started within the next 24 hours.'
    },
    [LOCALES.WELSH]: {
        'createEnquiryPage.page.title': 'Ymholiad newydd - NUAR',
        'createEnquiryPage.title': 'Ymholiad newydd',
        'createEnquiryPage.subtitle': '[This enquiry will be available for review by the relevant asset owners and their third parties.]',
        'createEnquiryPage.title.summary': 'Crynodeb ymholiad newydd',
        'createEnquiryPage.select.enquiry.type.title': 'Math o ymholiad cyfleustod',
        'createEnquiryPage.select.enquiry.type.subtitle': '[Enquiry type]',
        'createEnquiryPage.enquiry.type.title': '[Utility enquiry type]',
        'createEnquiryPage.enquiry.type.subtitle': '[The nature of this enquiry]',
        'createEnquiryPage.select.enquiry.type.description': '[Organisational sponsor]',
        'createEnquiryPage.planned.work': 'Gwaith wedi\'i gynllunio',
        'createEnquiryPage.unplanned.work': 'Gwaith heb ei gynllunio neu frys',
        'createEnquiryPage.enquiry.details': 'Manylion ymholiad',
        'createEnquiryPage.radio.hint': 'Dywedwch fwy wrthym am natur y cais ymholiad cyfleustod hwn.',
        'createEnquiryPage.no.enquiry.types': 'Nid oes gennych fynediad i greu ymholiad wedi\'i gynllunio na brys. Cysylltwch â\'ch gweinyddwr.',
        'createEnquiryPage.more.info.about.enquiry.types': '[Working for a different organisation?]',
        'createEnquiryPage.enquiry.type.info.unplanned': '[If this enquiry is on behalf of a different organisation, you will need to switch to that account.]',
        'createEnquiryPage.enquiry.type.unplanned.notice': '[It is assumed that work will be started within the next 24 hours.]'
    }
};
